import { FindingsLabel } from '@app/icare/components/findings'
import { PatientAnamnesisEditDrawer } from '@app/icare/entities/patient/edits/PatientAnamnesisEditDrawer'
import { PatientBodyHeightEditDrawer } from '@app/icare/entities/patient/edits/PatientBodyHeightEditDrawer'
import { PatientCareLevelEditDrawer } from '@app/icare/entities/patient/edits/PatientCareLevelEditDrawer'
import { PatientMedicalSupplyAccessEditDrawer } from '@app/icare/entities/patient/edits/PatientMedicalSupplyAccessEditDrawer'
import { PatientMobilityEditDrawer } from '@app/icare/entities/patient/edits/PatientMobilityEditDrawer'
import { PatientWeightEditDrawer } from '@app/icare/entities/patient/edits/PatientWeightEditDrawer'
import { selectByFindingId } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { AddButton } from '@pkg/ui/button'
import { DrawerSaveDropdown } from '@pkg/ui/drawer/DrawerSaveDropdown'
import { useRouterTabs } from '@pkg/ui/hooks'
import { useExtra, useTabs } from '@pkg/ui/layout/PageContainer'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/anamnese')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const tabs = useRouterTabs({ basePath: `/patienten/${id}/anamnese` })

  useTabs(
    {
      ...tabs,
      items: [
        {
          key: '/',
          label: t`Übersicht`,
        },
        {
          key: '/diagnose',
          label: <FindingsLabel label={t`Diagnose`} selector={selectByFindingId('AnamnesisDiagnosisRequired')} />,
        },
        {
          key: '/koerpergroesse',
          label: t`Körpergröße`,
        },
        {
          key: '/pflegegrad',
          label: <FindingsLabel label={t`Pflegegrad`} selector={selectByFindingId('AnamnesisCareLevelRequired')} />,
        },
        {
          key: '/gewicht',
          label: t`Gewicht`,
        },
        {
          key: '/mobilitaet',
          label: t`Mobilität`,
        },
        {
          key: '/zugang',
          label: t`Zugänge`,
        },
      ],
    },
    [tabs.activeKey],
  )

  useExtra(
    <DrawerSaveDropdown
      items={[
        {
          key: 'edit-diagnosis',
          label: t`Diagnose`,
          onClick: () => PatientAnamnesisEditDrawer.show({ patientId: id }),
        },
        {
          key: 'edit-koerpergroesse',
          label: t`Körpergröße`,
          onClick: () => PatientBodyHeightEditDrawer.show({ patientId: id }),
        },
        {
          key: 'add-care-level',
          label: t`Pflegegrad`,
          onClick: () => PatientCareLevelEditDrawer.show({ patientId: id }),
        },
        {
          key: 'add-weight',
          label: t`Gewicht`,
          onClick: () => PatientWeightEditDrawer.show({ patientId: id }),
        },
        {
          key: 'add-mobility',
          label: t`Mobilität`,
          onClick: () => PatientMobilityEditDrawer.show({ patientId: id }),
        },
        {
          key: 'add-access',
          label: t`Zugang`,
          onClick: () => PatientMedicalSupplyAccessEditDrawer.show({ patientId: id }),
        },
      ]}
    >
      <AddButton>
        <Trans>Angaben ergänzen</Trans>
      </AddButton>
    </DrawerSaveDropdown>,
  )

  return <Outlet />
}
